module.exports = __webpack_public_path__ + "static/media/Edward De Guzman.5a967ede.png";